import { IValues } from "@rentiohq/shared-frontend/dist/redux/form/form.utils";
import { ERentioMoveService } from "@rentiohq/shared-frontend/dist/redux/moveRequest/moveRequest.types";
import { EContractMemberTypes } from "@rentiohq/shared-frontend/dist/types/contract.types";
import { EField, IExtraData } from "./schema.requestRentioMoveService.types";

export const getInitialValues = (extraData: IExtraData): IValues => {
  const { contract, previousContract } = extraData || {};

  const getNewTenant = () => {
    if (!contract?.members) {
      return [];
    }

    const newTenantIds =
      contract.members
        .filter(member => member.roles.includes(EContractMemberTypes.Tenant))
        .map(member => member.account.id) || [];

    return newTenantIds?.length > 0 ? [newTenantIds[0]] : [];
  };

  const getDepartingTenant = () => {
    if (!contract?.members) {
      return [];
    }

    const departingTenantIds =
      previousContract?.members
        .filter(member => member.roles.includes(EContractMemberTypes.Tenant))
        .map(member => member.account.id) || [];

    return departingTenantIds?.length > 0 ? [departingTenantIds[0]] : [];
  };

  const result: { [key: string]: any } = {
    [EField.MoveDate]: contract.startDate || undefined,
    [EField.NoContract]: "no",
    [EField.ResidentCount]: undefined,
    [EField.DepartingTenant]: getDepartingTenant(),
    [EField.DepartingTenantFirstName]: undefined,
    [EField.DepartingTenantLastName]: undefined,
    [EField.DepartingTenantEmail]: undefined,
    [EField.NewTenant]: getNewTenant(),
    [EField.Services]: [ERentioMoveService.Energy],
  };

  return result;
};
